// extracted by mini-css-extract-plugin
export default {"status":"styles__status___HNKKh"};